// extracted by mini-css-extract-plugin
export var createdDate = "_o5-1";
export var divider = "_o5-2";
export var headerDivider = "_o5-3";
export var messagesCard = "_o5-0";
export var messagesContainer = "_o5-6";
export var messagesContainerWrapper = "_o5-4";
export var showLeftPanelButton = "_o5-8";
export var topButtons = "_o5-7";
export var withPadding = "_o5-5";